var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 0C8.8125 0 8.5 0.34375 8.5 0.75V5.75C8.5 6.1875 8.8125 6.5 9.25 6.5H15.25C15.6562 6.5 16 6.1875 16 5.75V0.75C16 0.34375 15.6562 0 15.25 0H9.25ZM6.75 0H0.75C0.3125 0 0 0.34375 0 0.75V5.75C0 6.1875 0.3125 6.5 0.75 6.5H6.75C7.15625 6.5 7.5 6.1875 7.5 5.75V0.75C7.5 0.34375 7.15625 0 6.75 0ZM0 8.25V13.25C0 13.6875 0.3125 14 0.75 14H6.75C7.15625 14 7.5 13.6875 7.5 13.25V8.25C7.5 7.84375 7.15625 7.5 6.75 7.5H0.75C0.3125 7.5 0 7.84375 0 8.25ZM9.25 14H15.25C15.6562 14 16 13.6875 16 13.25V8.25C16 7.84375 15.6562 7.5 15.25 7.5H9.25C8.8125 7.5 8.5 7.84375 8.5 8.25V13.25C8.5 13.6875 8.8125 14 9.25 14Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.33ef0581.svg";
export { ForwardRef as ReactComponent };